import React from 'react';
import { useHistory } from 'react-router-dom';
import BrowserLocationUtils from '../utils/BrowserLocationUtils';
import BaseLink from "./BaseLink";
const Link = ({ doNotAddWrapper = false, ...rest }) => {
    const history = useHistory();
    const updateBrowserLocation = (event) => {
        event.preventDefault();
        // if CTRL + Click (Windows) or CMD + Click (Mac)
        if (event.ctrlKey || event.metaKey) {
            let url = rest.to.toString();
            if (!doNotAddWrapper) {
                url = '/o' + url;
            }
            // add /o when opening new tabs to keep wrapper
            window.open(url, '_blank');
        }
        else {
            BrowserLocationUtils.updateBrowserLocationWithPush(rest.to.toString(), history);
        }
    };
    return React.createElement(BaseLink, { updateBrowserLocation: updateBrowserLocation, ...rest });
};
export default Link;
//# sourceMappingURL=Link.js.map